import { useStyles } from './styles';
import AppNumberInput from 'components/FormElements/AppNumberInput';

type Props = any; //TODO: define types

const TotalSaleValueCell: React.FC<Props> = ({
  cell,
  setOverride,
  disableTable,
}) => {
  const { classes } = useStyles();

  const defaultValue =
    Number(cell.sharesAllocatedForSale) * Number(cell.sharePrice);

  // Ensure totalSaleValue is never NaN
  const totalSaleValue = Number(cell.totalSaleValue) || 0;
  const isInputChanged = totalSaleValue !== defaultValue;
  const className = isInputChanged ? classes.inputChanged : '';

  return (
    <AppNumberInput
      key={`total-sale-${cell.shareholdingId}`}
      disabled={disableTable}
      decimals={2}
      placeholder="0"
      defaultValue={0}
      min={0}
      currencyStartAdornment
      value={totalSaleValue}
      onChange={(newValue) => {
        setOverride(cell.shareholdingId, {
          totalSaleValue: Number(newValue) || 0,
        });
      }}
      className={className}
    />
  );
};

export default TotalSaleValueCell;
